import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BrowserService } from './browser.service';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private cookieService: CookieService,
    private browserService: BrowserService
  ) {}

  public get = (key: string) => {
    if (isPlatformServer(this.platformId)) return;
    try {
      let string = sessionStorage.getItem(key);
      if (!string) string = localStorage.getItem(key);
      return string ? JSON.parse(string) : undefined;
    } catch (err) {
      console.warn(err);
    }
  };

  public has = (key: string) => {
    try {
      if (isPlatformServer(this.platformId)) return;
      let string = sessionStorage.getItem(key);
      if (!string) string = localStorage.getItem(key);
      return !!string;
    } catch (err) {
      console.warn(err);
    }
  };

  public set = (key: string, data: unknown, session = false) => {
    try {
      if (isPlatformServer(this.platformId)) return;
      if (session) sessionStorage.setItem(key, JSON.stringify(data));
      else localStorage.setItem(key, JSON.stringify(data));
    } catch (err) {
      console.warn(err);
    }
  };

  public remove = (key: string) => {
    try {
      if (isPlatformServer(this.platformId)) return;
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    } catch (err) {
      console.warn(err);
    }
  };

  private getDomain(): string {
    const customDomain = this.browserService.getTenantCustomDomain();
    if (customDomain) return customDomain;
    const url = this.browserService.getCorrectPicflowUrl();
    const domain = url.split('://')[1].split(':')[0];
    return domain;
  }

  public setCookie = (key: string, data: unknown) => {
    if (isPlatformServer(this.platformId)) return;

    this.cookieService.set(`PICFLOW_${key}`, JSON.stringify(data), {
      expires: 365,
      sameSite: 'Lax',
      domain: this.getDomain(),
      path: '/',
    });
  };

  public getCookie = (key: string) => {
    if (isPlatformServer(this.platformId)) return;
    try {
      const cookieVal = this.cookieService.get(`PICFLOW_${key}`);
      if (!cookieVal) return;
      const resp = JSON.parse(cookieVal);
      return resp;
    } catch (err) {
      console.log('getCookie error', key, err);
    }
  };

  public removeCookie = (key: string) => {
    if (isPlatformServer(this.platformId)) return;
    this.cookieService.delete(`PICFLOW_${key}`, '/', this.getDomain());
  };

  public getAny = (key: string) => {
    return this.get(key) || this.getCookie(key);
  };

  public hasAny = (key: string) => {
    return this.has(key) || !!this.getCookie(key);
  };
}
